export const DAY_NAMES = ['Ma', 'Di', 'Wo', 'Do', 'Vr'];
export const DAY_NAMES_LONG = ['maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag'];
